/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_ExternalInputs */



/**
* | output |
* | --- |
* | "External meetings" |
*
* @param {Agenda_Filter_ExternalInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_external = /** @type {((inputs?: Agenda_Filter_ExternalInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_ExternalInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Externe meetings")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réunions externes")
	return /** @type {LocalizedString} */ ("External meetings")
});